<div class="new-conditions row" [hidden]="action">
  <div class="flex flex-gap">
    <div>
      <app-button icon="mdi mdi-cog-outline" title="Control something" label="Send value to a sensor" (click)="newAction('switch')" />
    </div>
    <div>
      <app-button icon="mdi mdi-toggle-switch-variant-off" title="Operate Equipment" label="Operate equipment" (click)="newAction('operate')" />
    </div>
  </div>
</div>
@if (action) {
  <app-dialog [canScroll]="true" (onClose)="action = null">
    <app-rule-action-new [modifyAction]="_modifyAction" [defaultSite]="defaultSite" [defaultGateway]="defaultGateway" (cancel)="newRuleActionCancelled()" (submit)="newRuleActionSubmitted($event)"> </app-rule-action-new>
  </app-dialog>
}

@if (operate()) {
  <app-dialog [canScroll]="true" (onClose)="operate.set(null)" [dimensions]="{ width: 1024, height: 620 }" header="Operate Equipment" ]>
    @if (equpiment()) {
      <app-toolbar>
        <div class="right">
          <!-- <app-button label="Started Delay" [selected]="false" /> -->
          <app-select
            [list]="[
              { id: 'new', title: 'New Alarm' },
              { id: 'resolved', title: 'Alarm Resolved' }
            ]"
            [value]="'new'"
            (onSelected)="triggerSelected($event)" />
        </div>
      </app-toolbar>
      <table class="table table-hover mt-1">
        <thead>
          <tr>
            <th>Equipment</th>
            <th>Type</th>
            <th>Gateway</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (eq of equpiment(); track eq.id) {
            <tr (click)="deviceActionClick(eq)">
              <td>{{ eq.device.title }}</td>
              <td>{{ eq.device.deviceType }}</td>
              <td>{{ eq.device.gatewayId }}</td>
              <td>{{ eq.title }}</td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <app-please-wait></app-please-wait>
    }
  </app-dialog>
}
